export type LandingVisit = "first" | "returning";

export interface LandingChoice {
  visit: LandingVisit;
  /** Secondary action that opens the transfers hub. */
  showHistory: boolean;
  /** Whether the compose action can be used. */
  canCompose: boolean;
}

/**
 * First visit keeps a single start button. A returning sender sees history
 * plus compose; compose stays visible but disabled when the account cannot send.
 */
export function landingChoice(
  operationCount: number,
  canSend: boolean
): LandingChoice {
  if (operationCount > 0) {
    return {
      visit: "returning",
      showHistory: true,
      canCompose: canSend,
    };
  }

  return {
    visit: "first",
    showHistory: false,
    canCompose: canSend,
  };
}
